import { useEffect, useState } from 'react';

/**
 * Returns `true` while the document is visible (`visibilityState === 'visible'`)
 * and `false` while it is hidden (other tab focused, window minimised, etc.).
 *
 * Use to pause polling / auto-refresh / GPS subscriptions when the user can't
 * see the page, then resume on `visibilitychange` back to visible.
 */
export function useDocumentVisibility(): boolean {
  const [visible, setVisible] = useState<boolean>(
    typeof document === 'undefined' ? true : document.visibilityState === 'visible',
  );
  useEffect(() => {
    const onChange = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);
  return visible;
}
